<template>
  <div class="Interface__Container">
    <div :class="[enterCode ? 'blur':'']">
      <Canvas />
      <NavigationPage />
      <Header />
      <Controls v-if="step === 1 || step === 2" />
      <NavigationBar v-if="step > 0" />
    </div>
    <Code v-if="enterCode" />
    <LanguageSelector />
    <Help v-if="step === 1 || step === 2" />
  </div>
</template>

<script>
import Canvas from '@/components/Canvas/Canvas'
import LanguageSelector from '@/components/Language/LanguageSelector'
import Help from '@/components/Help/Help'
import NavigationBar from '@/components/NavigationBar/NavigationBar'
import Header from '@/components/Header/Header'
import NavigationPage from '@/components/NavigationPage/NavigationPage'
import Controls from '@/components/Controls/Controls'
import Code from '@/components/Code/Code'
import { mapGetters } from 'vuex'

export default {
  components: {
    Canvas,
    LanguageSelector,
    NavigationBar,
    NavigationPage,
    Header,
    Controls,
    Code,
    Help
  },
  computed: {
    ...mapGetters(['step', 'enterCode'])
  },
  methods: {
    ShowHelp () {

    }
  }
}
</script>

<style scoped>
.Interface__Container{
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.blur{
  filter: blur(4px);
}
</style>
